import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const usePasswordResetEmail = () => {
  const createPasswordResetEmail = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v2/password-reset-email/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createPasswordResetEmail);
};

export default usePasswordResetEmail;
